import React, { useState, useEffect } from "react";
import { Menu, X, MessageCircle } from "lucide-react";
import { NAV_LINKS, WHATSAPP_URL, JOTFORM_URL } from "../constants";

const Logo = () => (
  <a href="#top" className="flex items-center gap-2 no-underline">
    <span
      style={{
        width: 34,
        height: 34,
        borderRadius: 10,
        background: "linear-gradient(135deg,#5446EA,#C04ABF)",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        fontWeight: 800,
        fontSize: 16,
        letterSpacing: "-0.04em",
      }}
    >
      AE
    </span>
    <span style={{ color: "#1A1352", fontWeight: 800, fontSize: 18, letterSpacing: "-0.02em" }}>
      Active<span style={{ color: "#5446EA" }}>English</span>
    </span>
  </a>
);

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      id="top"
      style={{
        position: "sticky",
        top: 0,
        zIndex: 50,
        backdropFilter: scrolled ? "saturate(180%) blur(14px)" : "none",
        background: scrolled ? "rgba(244, 241, 234, 0.85)" : "transparent",
        borderBottom: scrolled ? "1px solid rgba(26,19,82,0.08)" : "1px solid transparent",
        transition: "all 220ms ease",
      }}
    >
      <div
        style={{
          maxWidth: 1240,
          margin: "0 auto",
          padding: "14px 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 16,
        }}
      >
        <Logo />

        <nav className="hidden md:flex" style={{ gap: 2, alignItems: "center" }}>
          {NAV_LINKS.map((l) => (
            <a key={l.href} href={l.href} className="nav-link">
              {l.label}
            </a>
          ))}
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="nav-link">
            <MessageCircle size={15} /> WhatsApp
          </a>
        </nav>

        <div className="hidden md:flex" style={{ gap: 10, alignItems: "center" }}>
          <a href={JOTFORM_URL} target="_blank" rel="noreferrer" className="btn-orange">
            Empieza ahora
          </a>
        </div>

        <button
          className="md:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Menú"
          style={{
            background: "#fff",
            border: "1px solid rgba(26,19,82,0.1)",
            borderRadius: 12,
            padding: 10,
            cursor: "pointer",
          }}
        >
          {open ? <X size={20} color="#1A1352" /> : <Menu size={20} color="#1A1352" />}
        </button>
      </div>

      {open && (
        <div className="mobile-menu md:hidden">
          {NAV_LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)}>
              {l.label}
            </a>
          ))}
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" onClick={() => setOpen(false)}>
            WhatsApp
          </a>
          <a
            href={JOTFORM_URL}
            target="_blank"
            rel="noreferrer"
            onClick={() => setOpen(false)}
            style={{ background: "#FF4F1A", color: "#fff", textAlign: "center", marginTop: 6 }}
          >
            Empieza ahora
          </a>
        </div>
      )}
    </header>
  );
};

export default Navbar;
